import { Grid, Typography } from "@mui/material";

export default function UserManagementDesc() {
  return (
    
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ ml: 2 }}>
          <Typography style={{ whiteSpace: "pre-line" }}>
            Use this page to add or remove users, assign roles, and manage access permissions for your organization.
          </Typography>
        </Grid>
      </Grid>

  );
}
